var map = {
	"./cs.json": 62436,
	"./da.json": 59905,
	"./de.json": 73685,
	"./en-GB.json": 6009,
	"./en.json": 6425,
	"./es.json": 93130,
	"./fr-CA.json": 80785,
	"./fr.json": 79490,
	"./it.json": 29403,
	"./ja.json": 4943,
	"./ko.json": 91464,
	"./nl.json": 88924,
	"./no.json": 24937,
	"./pl.json": 2382,
	"./pt-BR.json": 97881,
	"./ru.json": 52971,
	"./sv.json": 32731,
	"./zh-Hans.json": 15747,
	"./zh-Hant.json": 41934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5537;